:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  padding: 2px;
  display: flex;
  flex-wrap: wrap;
  #risks-incident-chart {
    width: 100%;
    align-items: center;
    justify-content: center;
    display: grid;
    .gz-general-donut-chart {
      width: inherit;
    }
  }

  #associated-risks-title {
    padding-left: var(--spacer);
  }

  #subtitle-risks {
    padding-left: var(--spacer);
    margin-top: calc(var(--spacer) * 3);
    color: var(--chart-300-icon-buttons);
  }

  #view-all-risks-button {
    padding-top: var(--spacer);
  }

  #incident-risks-sections {
    height: inherit;
    width: inherit;
    .gz-risk-incident-section {
      width: inherit;
    }
  }
}
